import list from './list'

export default {
    list: list,
    name: "warehousecompanies",
    key: "p_warehousecompanies",
}